//
// Copyright 2022 DXOS.org
//
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_any } from "@bufbuild/protobuf/wkt";
/**
 * Describes the file dxos/edge/messenger.proto.
 */
export const file_dxos_edge_messenger = /*@__PURE__*/ fileDesc("ChlkeG9zL2VkZ2UvbWVzc2VuZ2VyLnByb3RvEhNkeG9zLmVkZ2UubWVzc2VuZ2VyIuQCCgRQZWVyEhYKCXN3YXJtX2tleRgBIAEoCUgAiAEBEh0KDGlkZW50aXR5X2tleRgCIAEoCUICGAFIAYgBARIQCghwZWVyX2tleRgDIAEoCRJDChBjb25uZWN0aW9uX3N0YXRlGAUgASgOMiQuZHhvcy5lZGdlLm1lc3Nlbmdlci5Db25uZWN0aW9uU3RhdGVIAogBARIWCgljb25uZWN0ZWQYBiABKAFIA4gBARIZCgxkaXNjb25uZWN0ZWQYByABKAFIBIgBARIZCgxpZGVudGl0eV9kaWQYCCABKAlIBYgBARISCgVzdGF0ZRgEIAEoDEgGiAEBQgwKCl9zd2FybV9rZXlCDwoNX2lkZW50aXR5X2tleUITChFfY29ubmVjdGlvbl9zdGF0ZUIMCgpfY29ubmVjdGVkQg8KDV9kaXNjb25uZWN0ZWRCDwoNX2lkZW50aXR5X2RpZEIICgZfc3RhdGUixgIKB01lc3NhZ2USFgoJdGltZXN0YW1wGAEgASgJSACIAQESLgoGc291cmNlGAogASgLMhkuZHhvcy5lZGdlLm1lc3Nlbmdlci5QZWVySAGIAQESKQoGdGFyZ2V0GAsgAygLMhkuZHhvcy5lZGdlLm1lc3Nlbmdlci5QZWVyEhcKCnNlcnZpY2VfaWQYFCABKAlIAogBARI9Cg10cmFjZV9jb250ZXh0GBUgASgLMiEuZHhvcy5lZGdlLm1lc3Nlbmdlci5UcmFjZUNvbnRleHRIA4gBARIqCgdwYXlsb2FkGGQgASgLMhQuZ29vZ2xlLnByb3RvYnVmLkFueUgEiAEBQgwKCl90aW1lc3RhbXBCCQoHX3NvdXJjZUINCgtfc2VydmljZV9pZEIQCg5fdHJhY2VfY29udGV4dEIKCghfcGF5bG9hZCJLCgxUcmFjZUNvbnRleHQSEwoLdHJhY2VwYXJlbnQYASABKAkSFwoKdHJhY2VzdGF0ZRgCIAEoCUgAiAEBQg0KC190cmFjZXN0YXRlIpQBCgxTd2FybVJlcXVlc3QSPQoGYWN0aW9uGAEgASgOMiguZHhvcy5lZGdlLm1lc3Nlbmdlci5Td2FybVJlcXVlc3QuQWN0aW9uSACIAQESEQoJc3dhcm1LZXlzGAIgAygJIicKBkFjdGlvbhIICgRJTkZPEAASCAoESk9JThABEgkKBUxFQVZFEAJCCQoHX2FjdGlvbiJ+Cg1Td2FybVJlc3BvbnNlEhAKCHN3YXJtS2V5GAEgASgJEigKBXBlZXJzGAIgAygLMhkuZHhvcy5lZGdlLm1lc3Nlbmdlci5QZWVyEjEKDmluYWN0aXZlX3BlZXJzGAMgAygLMhkuZHhvcy5lZGdlLm1lc3Nlbmdlci5QZWVyIi8KC1RleHRNZXNzYWdlEhQKB21lc3NhZ2UYASABKAlIAIgBAUIKCghfbWVzc2FnZSpSCg9Db25uZWN0aW9uU3RhdGUSDQoJQ09OTkVDVEVEEAASFwoTRElTQ09OTkVDVEVEX05PUk1BTBABEhcKE0RJU0NPTk5FQ1RFRF9BQlJVUFQQAmIGcHJvdG8z", [file_google_protobuf_any]);
/**
 * Describes the message dxos.edge.messenger.Peer.
 * Use `create(PeerSchema)` to create a new message.
 */
export const PeerSchema = /*@__PURE__*/ messageDesc(file_dxos_edge_messenger, 0);
/**
 * Describes the message dxos.edge.messenger.Message.
 * Use `create(MessageSchema)` to create a new message.
 */
export const MessageSchema = /*@__PURE__*/ messageDesc(file_dxos_edge_messenger, 1);
/**
 * Describes the message dxos.edge.messenger.TraceContext.
 * Use `create(TraceContextSchema)` to create a new message.
 */
export const TraceContextSchema = /*@__PURE__*/ messageDesc(file_dxos_edge_messenger, 2);
/**
 * Describes the message dxos.edge.messenger.SwarmRequest.
 * Use `create(SwarmRequestSchema)` to create a new message.
 */
export const SwarmRequestSchema = /*@__PURE__*/ messageDesc(file_dxos_edge_messenger, 3);
/**
 * @generated from enum dxos.edge.messenger.SwarmRequest.Action
 */
export var SwarmRequest_Action;
(function (SwarmRequest_Action) {
    /**
     * @generated from enum value: INFO = 0;
     */
    SwarmRequest_Action[SwarmRequest_Action["INFO"] = 0] = "INFO";
    /**
     * @generated from enum value: JOIN = 1;
     */
    SwarmRequest_Action[SwarmRequest_Action["JOIN"] = 1] = "JOIN";
    /**
     * @generated from enum value: LEAVE = 2;
     */
    SwarmRequest_Action[SwarmRequest_Action["LEAVE"] = 2] = "LEAVE";
})(SwarmRequest_Action || (SwarmRequest_Action = {}));
/**
 * Describes the enum dxos.edge.messenger.SwarmRequest.Action.
 */
export const SwarmRequest_ActionSchema = /*@__PURE__*/ enumDesc(file_dxos_edge_messenger, 3, 0);
/**
 * Describes the message dxos.edge.messenger.SwarmResponse.
 * Use `create(SwarmResponseSchema)` to create a new message.
 */
export const SwarmResponseSchema = /*@__PURE__*/ messageDesc(file_dxos_edge_messenger, 4);
/**
 * Describes the message dxos.edge.messenger.TextMessage.
 * Use `create(TextMessageSchema)` to create a new message.
 */
export const TextMessageSchema = /*@__PURE__*/ messageDesc(file_dxos_edge_messenger, 5);
/**
 * @generated from enum dxos.edge.messenger.ConnectionState
 */
export var ConnectionState;
(function (ConnectionState) {
    /**
     * @generated from enum value: CONNECTED = 0;
     */
    ConnectionState[ConnectionState["CONNECTED"] = 0] = "CONNECTED";
    /**
     * @generated from enum value: DISCONNECTED_NORMAL = 1;
     */
    ConnectionState[ConnectionState["DISCONNECTED_NORMAL"] = 1] = "DISCONNECTED_NORMAL";
    /**
     * @generated from enum value: DISCONNECTED_ABRUPT = 2;
     */
    ConnectionState[ConnectionState["DISCONNECTED_ABRUPT"] = 2] = "DISCONNECTED_ABRUPT";
})(ConnectionState || (ConnectionState = {}));
/**
 * Describes the enum dxos.edge.messenger.ConnectionState.
 */
export const ConnectionStateSchema = /*@__PURE__*/ enumDesc(file_dxos_edge_messenger, 0);
//# sourceMappingURL=messenger_pb.js.map